import { ResponsiveValues } from "./ResponsiveValues";

export type ResponsiveProp<T> = T | ResponsiveValues<T>;

export const isResponsiveProp = <T>(
  value: T | ResponsiveValues<T>
): value is ResponsiveValues<T> =>
  (value as ResponsiveValues<T>)?.mobileAndAbove !== undefined;
